module.exports = __webpack_public_path__ + "img/logo.9f9be4b1.png";